import _ from "lodash";
import store from "services/redux/store";
import { addDataByGuid, setData, setDataByGuid } from "services/redux/data/actions";
import { dataConstants } from "services/redux/data/constants";
import FetchCache from "utils/fetch/cached/FetchCache";
import FetchAppMessages from 'utils/fetch/FetchAppMessages'

export default class FetchCachedAppMessages
{
	static logName = 'FetchCachedAppMessages';
	static values = null;
	static cacheUpdatedAt = null;
	
	static construct = () => {
		return (
			FetchCache.initialize( this, {
				identifier: 'app_messages',
				tables: [ 'app_messages' ],
				onExpire: this.reload,
				updated_at_max_age: ( 5 * 60 ) // updated_at needs to be refresh at most each 5 minutes for this table
			}, this.process )
		);
	};

	static fetchAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchCache.sniff( this.cacheUpdatedAt, {
				onFresh: () => {
					if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
						callbackSuccess( this.values )
					}
				},
				onExpired: () => {
					this.reload( {callbackSuccess, callbackError, callbackStart} )
				}
		})
			);
		});
	}

	static reload = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchAppMessages.fetchAll({
					callbackStart: callbackStart,
					callbackError: callbackError,
					callbackSuccess: ( values ) => {
						// Save to object
						this.process( values );

						// Save to cache!
						FetchCache.storeData( this.cacheUpdatedAt, values, true );

						if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
							callbackSuccess( values );
						}
					}
				})
			);
		}
		);
	}

	static process = ( values ) => {
		this.values = values;
		
		store.dispatch( setData( dataConstants.APP_MESSAGES, this.values ) );
	}
}
